var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFylamyntTextLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "14px",
    viewBox: "0 0 113 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1528.000000, -1547.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1528.000000, 1547.040538)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "109.022536 2.12270077 112.986992 2.12270077 112.986992 0.0780404696 102.841731 0.0780404696 102.841731 2.12270077 106.806187 2.12270077 106.806187 12.5957318 109.022536 12.5957318"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "96.6765338 8.7405326 89.9962696 0.0780404696 87.9516093 0.0780404696 87.9516093 12.5957318 90.1367424 12.5957318 90.1367424 3.69911826 97.0199118 12.5957318 98.8616669 12.5957318 98.8616669 0.0780404696 96.6765338 0.0780404696"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "79.3983738 7.61674984 84.3773558 0.0780404696 81.8488445 0.0780404696 78.3058072 5.61891381 74.8095942 0.0780404696 72.2186506 0.0780404696 77.1820245 7.66357412 77.1820245 12.5957318 79.3983738 12.5957318"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "66.4436558 3.62107779 66.4436558 12.5957318 68.628789 12.5957318 68.628789 0.0780404696 66.2875749 0.0780404696 62.4792 5.99350807 58.6708251 0.0780404696 56.329611 0.0780404696 56.329611 12.5957318 58.5147441 12.5957318 58.5147441 3.65229398 62.4323757 9.52093729 62.4948081 9.52093729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19.275996 7.61674984 24.254978 0.0780404696 21.7264667 0.0780404696 18.1834294 5.61891381 14.6872164 0.0780404696 12.0962728 0.0780404696 17.0596467 7.66357412 17.0596467 12.5957318 19.275996 12.5957318"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "27.8292315 12.5957318 36.6009803 12.5957318 36.6009803 10.6135039 30.0143646 10.6135039 30.0143646 0.0780404696 27.8292315 0.0780404696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.027187,9.41688428e-14 L44.9825267,9.41688428e-14 L39.4728695,12.5957318 L41.7360432,12.5957318 C43.6402306,8.11620884 43.8587439,7.53870937 45.9658366,2.62215978 C48.0417131,7.41384461 48.3382669,8.14742503 50.2112382,12.5957318 L52.5368442,12.5957318 L47.027187,9.41688428e-14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.30242398 0.0780404696 4.39867621e-14 0.0780404696 4.39867621e-14 12.5957318 2.18513315 12.5957318 2.18513315 7.50749318 8.4908031 7.50749318 8.4908031 5.52526525 2.18513315 5.52526525 2.18513315 2.0602684 9.30242398 2.0602684"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFylamyntTextLogo);
export default __webpack_public_path__ + "static/media/fylamynt-text-logo.075e117186c64e5d346b53e5c5c3769f.svg";
export { ForwardRef as ReactComponent };